<template>
  <div :class="`episodes ${value ? 'visible' : ''}`">
    <div class="content">
      <div class="header">
        <span class="close" @click="$emit('input', false)">X</span>
        <div>
          <h2 v-t="'misc.episodes'" />
          <dropdown v-if="showPlaylistDropdown" v-model="selectedPlaylist" :options="playlistTitles" />
        </div>
      </div>
      <scroll-container ref="scroll" :horizontalPadding="45">
        <div class="video-thumbnail-container" v-for="(video, i) in videos" :key="video.id">
          <video-thumbnail
            @click="$emit('input', false)"
            :video="video"
            :playlistId="selectedPlaylist.id"
            :playlistGroupId="playlistGroupData.id"
            :index="i + 1"
            :replaceRoute="true"
            :hasAnimation="false"
            :isHighlighted="playingVideoId === video.id"
          />
        </div>
      </scroll-container>
    </div>
    <ruffle-icon />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'episodes',
  props: {
    value: Boolean
  },
  data: () => ({
    selectedPlaylist: ''
  }),
  watch: {
    selectedPlaylist() {
      this.$refs.scroll.resetScroll()
    }
  },
  computed: {
    ...mapGetters({
      getVideosFromPlaylist: 'contentTree/findVideosFromPlaylist',
      getPlaylistsFromPlaylistGroup: 'contentTree/findPlaylistsFromPlaylistGroup'
    }),
    ...mapState({
      playlistData: state => state.video.playlistData,
      playlistGroupData: state => state.video.playlistGroupData,
      playingVideoId: state => state.video.id
    }),
    videos() {
      return this.getVideosFromPlaylist(this.selectedPlaylist.id)
    },
    playlistTitles() {
      return this.getPlaylistsFromPlaylistGroup(this.playlistGroupData.id)
        .map(it => ({
          label: it.title,
          id: it.id
        }))
    },
    showPlaylistDropdown() {
      return this.playlistTitles.length > 1
    }
  },
  created() {
    this.selectedPlaylist = {
      id: this.playlistData.id,
      label: this.playlistData.title
    }
  }
}
</script>

<style lang="scss" scoped>
.episodes {
  transition: transform 0.2s;
  transform: translateY(-100%);
  z-index: 1;

  &.visible {
    transform: translateY(0%);
  }

  .content {
    position: relative;
    padding: 25px 0;
    background-color: $player-hud-background-color;
    cursor: auto;

    .header {
      width: 100%;
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      color: white;
      padding: 0 56px 1.4rem 56px;

      & > div {
        width: 100%;
        display: inline-flex;
        align-items: center;
        flex-wrap: wrap-reverse;

        & > h2 {
          margin: 0;
          margin-right: 16px;
        }
      }

      & > .close {
        position: absolute;
        top: 0;
        right: 0;
        padding: 8px;
        cursor: pointer;
        font-size: 1.4rem;
      }
    }

    .video-thumbnail-container {
      width: 280px;
      padding-right: 20px;
      color: white;

      @media screen and (max-width: 725px) {
        width: 160px;
      }

      @media screen and (max-height: 570px) {
        width: 140px;
      }
    }

    @media (hover: none),
         (max-width: 425px) and (orientation: portrait),
         (max-width: 812px) and (orientation: landscape) {
      padding-bottom: 15px;

      .header {
        padding: 16px 16px 0 16px;

        & > div > .dropdown {
          width: 100%;
          margin-bottom: 1.4rem;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.video-thumbnail-container .video .image-container {
  height: 180px;

  @media screen and (max-width: 725px) {
    height: 120px;
  }

  @media screen and (max-height: 570px) {
    height: 100px;
  }

  @media screen and (max-height: 570px) {
    height: 90px;
  }
}

.content > .scroll-container > .scroller-button {
  top: calc(50% - 0.45rem - 5px - 46px);
}
</style>
